import {
  IsArray,
  IsDate,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsNumber,
  IsInt,
  IsBoolean,
  ValidateNested,
} from "class-validator";

import { ContactDto } from "../common";
import { Type } from "class-transformer";

export class SessionDto {
  //
  @IsOptional()
  @IsString()
  _id?: string;

  @IsNotEmpty()
  @IsDate()
  start_date: Date;

  @IsNotEmpty()
  @IsDate()
  end_date: Date;

  @IsOptional()
  @IsNumber()
  fee?: number;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ContactDto)
  instructors: ContactDto[];

  @IsOptional()
  @IsInt()
  regular_capacity?: number;

  @IsOptional()
  @IsInt()
  dropin_capacity?: number;

  @IsOptional()
  @IsBoolean()
  waitlist_enabled?: boolean;

  @IsOptional()
  @IsNumber()
  waitlist_size?: number;
}
